export default __webpack_public_path__ + "static/0126-2ef34c97d69427ec74924c14f69b9104.png";